import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  id: "user-info",
  class: "user-info"
}
const _hoisted_2 = { class: "uk-text-bold" }
const _hoisted_3 = { class: "uk-text-meta uk-margin-small-bottom" }
const _hoisted_4 = { class: "uk-text-small uk-text-bold uk-margin-small-bottom" }
const _hoisted_5 = { class: "uk-list uk-margin-remove feature-roles" }
const _hoisted_6 = { class: "feature-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.user.username), 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.user.email), 1),
    _cache[0] || (_cache[0] = _createElementVNode("hr", { class: "uk-margin-small" }, null, -1)),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('header.feature_access')), 1),
    _createElementVNode("ul", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.permissions, (role, key) => {
        return (_openBlock(), _createElementBlock("li", {
          key: key,
          class: "uk-flex uk-flex-between"
        }, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.humanizeFeatureKey(key)), 1),
          _createElementVNode("span", {
            class: _normalizeClass(["role", `role-${role}`])
          }, _toDisplayString(role), 3)
        ]))
      }), 128))
    ])
  ]))
}